export default "__VITE_ASSET__B5AO6o9m__"